var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",attrs:{"type":"button","title":_vm.label},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon,"size":"lg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }